import { render } from "./MainMenu.vue?vue&type=template&id=1d2c3212"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=1d2c3212&lang=scss"
script.render = render

export default script